import Button, { ButtonProps } from 'react-bootstrap/Button';

type SecondaryButtonProps =
  Omit<
  ButtonProps,
  'className' | 'bsPrefix' | 'variant'>;

const SecondaryButton = (props: SecondaryButtonProps) => <Button variant='nmi-secondary' {...props} />;

export default SecondaryButton;
